import moment from "moment-jalaali";

const formatDateToPersian = (dateString: any) => {
  const date = moment(dateString).format(" HH:mm - jD / jMM / jYYYY ");
  return date;
};

export default formatDateToPersian;
